import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  value: undefined
}
const _hoisted_3 = ["value"]

import { reactive, watch, onMounted } from 'vue';
import * as service from "@/services/ParametrosBoleto";

interface iProps {
    modelValue?: any,
    disabled?: boolean,
    comIndefinido?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownParamBoleto',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    comIndefinido: { type: Boolean }
  },
  emits: ['change', "update:modelValue",],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

var props = __props;

var controle = reactive({
    valor: props.modelValue,
    comIndefinido: props.comIndefinido,
    disabled: props.disabled,
    itens:[] as service.IParamBoleto[],
    opcoes: {} as service.IEnums
})

onMounted(async () => {
    buscar();
    controle.valor = props.modelValue != null ? props.modelValue : undefined;
})

watch(() => props.modelValue, async (novo: any) => {
    controle.valor = novo;
})


watch(() => props.disabled, async (novo: any) => {
    controle.disabled = novo;
})

const onChange = ()=> {
    emit("update:modelValue", controle.valor);
    emit("change", controle.valor);
}

function buscar() {
    service.obter().then((r) => {
        if (r != null) {
            controle.itens = r.dados;
        }
    })

    service.obterOpcoes().then((r) => {
        if (r != null) {
            controle.opcoes = r;
        }
    })  
}



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps({
    class: "form-select form-select-sm",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).valor) = $event)),
    disabled: _unref(controle).disabled
  }, _ctx.$attrs, { onChange: onChange }), [
    (_unref(controle).comIndefinido == true)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, "- Selecione -"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
      return (_openBlock(), _createElementBlock("option", {
        key: idx,
        value: item.paramBoletoId
      }, _toDisplayString(_unref(controle).opcoes.tipoCobranca?.find(a=> a.posicao == item.tipoCobranca)?.texto) + ", Agencia: " + _toDisplayString(item.cedenteAgencia) + "-" + _toDisplayString(item.cedenteAgenciaDigito) + ", Conta: " + _toDisplayString(item.cedenteConta) + "-" + _toDisplayString(item.cedenteContaDigito) + ", Código: " + _toDisplayString(item.cedenteCodigo), 9, _hoisted_3))
    }), 128))
  ], 16, _hoisted_1)), [
    [_vModelSelect, _unref(controle).valor]
  ])
}
}

})